<p>
  Records are a type of data in a dataset, similar to files. However, records are always in JSON
  format and are searchable. They can can also be added, removed and modified even after the dataset
  is published.
</p>
<p>Records are organized in a nested data structure; only the top level is listed on this page.</p>
<p>
  Refer to the
  <a target="_blank" href="https://docs.data.npolar.no/api/#/record">API documentation</a>
  for filtering and querying options.
</p>

<app-list [resource]="records" [disableClear]="true">
  @if (!records.error()) {
    <mat-action-list>
      @for (record of records.value()?.items; track record.id) {
        <mat-list-item lines="3" (click)="openRecord(record)">
          <mat-icon matListItemIcon>
            @switch (record.type) {
              @case ('station') {
                cell_tower
              }
              @default {
                data_object
              }
            }
          </mat-icon>
          <span matListItemTitle>{{ record.content['title'] || record.id }}</span>
          <span matListItemLine>{{ record.type }}</span>
          <span matListItemLine>{{ record.modified | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
        </mat-list-item>
      }
    </mat-action-list>

    <mat-paginator
      showFirstLastButtons
      (page)="filter($event.pageIndex, $event.pageSize)"
      [length]="records.value()?.count"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>
